export enum ISuggestionType {
  SUGGESTION = 'SUGGESTION',
  COMPLAINT = 'COMPLAINT',
  OBSERVATION = 'OBSERVATION',
  INCIDENCE = 'INCIDENCE',
  OBJECT_LOST = 'OBJECT_LOST',
  OBJECT_FOUND = 'OBJECT_FOUND'
}

export enum ISuggestionComplaint {
  SERVICE_IMPROVEMENT = 'SERVICE_IMPROVEMENT',
  TIMETABLES = 'TIMETABLES',
  VEHICLE_CONDITIONS = 'VEHICLE_CONDITIONS',
  DRIVER = 'DRIVER',
  PUNCTUALITY = 'PUNCTUALITY',
  APP = 'APP',
  SIGN_UP_AND_LOG_IN = 'SIGN_UP_AND_LOG_IN',
  BOOKING_PROCESS = 'BOOKING_PROCESS',
  BOOKINGS_AND_CANCELLATIONS = 'BOOKINGS_AND_CANCELLATIONS',
  PENALTIES = 'PENALTIES',
  CUSTOMER_SERVICE = 'CUSTOMER_SERVICE',
  BACKOFFICE = 'BACKOFFICE',
  OTHERS_ABOUT_APP = 'OTHERS_ABOUT_APP',
  OBJECT_LOST = 'OBJECT_LOST',
  OTHERS = 'OTHERS'
}

export enum IIncidenceAffair {
  DRIVER_APP = 'DRIVER_APP',
  ROADMAP = 'ROADMAP',
  ROUTE = 'ROUTE',
  PAX = 'PAX',
  VEHICLE = 'VEHICLE',
  DELAY = 'DELAY',
  EMERGENCY = 'EMERGENCY',
  ACCIDENT = 'ACCIDENT',
  FULL_BUS = 'FULL_BUS',
  OBJECT_FOUND = 'OBJECT_FOUND'
}

export type ISuggestionAffair = ISuggestionComplaint | IIncidenceAffair
